export const CCM_MODE = {
	loading: -2,
	list: -1,
	drawRectangles: 0,
	selectAnchorPoint: 1,
	selectGridpoints: 2,
} as const;

export type CcmMode = typeof CCM_MODE[keyof typeof CCM_MODE];
